module.exports = __webpack_public_path__ + "img/axis.682da5b.gif";